import theme from './theme';

const fontFamily = "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif";

export const fontStyles = {
    paragraphText: {
        fontSize: '0.875rem',
        fontWeight: 400,
        fontFamily,
    },
    mainHeadingText: {
        fontSize: '0.875rem',
        fontWeight: 600,
        fontFamily,
    },
    primaryText: {
        fontSize: '1.125rem',
        fontWeight: 600,
        lineHeight: 1.5,
        fontFamily,
    },
    btnText: {
        fontSize: '0.875rem',
        fontWeight: 600,
        textTransform: 'none',
        lineHeight: 1.5,
        fontFamily,
    },
    btnSmallText: {
        fontSize: '0.8125rem',
        fontWeight: 500,
        textTransform: 'none',
        lineHeight: 1.5,
        fontFamily,
    },
    smallText: {
        fontSize: '0.8125rem',
        fontWeight: 400,
        lineHeight: 1.5,
        fontFamily,
    },
    mediumText: {
        fontSize: '0.875rem',
        fontWeight: 500,
        lineHeight: 1.5,
        fontFamily,
    },
    largeText: {
        fontSize: '1rem',
        fontWeight: 600,
        lineHeight: 1.5,
        fontFamily,
    },
    formErrorText: {
        fontSize: '0.8125rem',
        fontWeight: 400,
        lineHeight: 1.5,
        fontFamily,
        color: '#DC2626',
    },
    drawerHeading: {
        fontSize: '1.0625rem',
        fontWeight: 700,
        lineHeight: 1.4,
        fontFamily,
    },
}
